import { atom } from 'jotai';
export const personalData=atom({})
